import ProfessionalThemeHeader from '@/components/common/Header/ProfessionalThemeHeader';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { companyImage } from '@/utils/common/env.constants';
import { Container, Dialog, Typography } from '@pwskills/rachnaui';
import React, { useContext, useEffect, useState } from 'react';
import Image from 'next/image';
import ribbon from '@/assets/icons/courseDescriptionPage/ribbon.svg';
import { useRouter } from 'next/router';
import CertificateSection from './CertificateSection';
import SelectionTabs from './SelectionTabs';

const GetCertified = ({ isAmateur = true }: { isAmateur?: boolean }) => {
  const [modelOpen, setModelOpen] = useState<boolean>(false);
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { certificateType } = courseDetails?.courseMetaDetails || {};
  const [certificate, setCertificate] = useState<string>(
    certificateType?.[0]?.certificateImage || ''
  );
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  useEffect(() => setCertificate(certificateType?.[0]?.certificateImage || ''), [certificateType]);

  if (!certificateType?.length) return null;

  const returnChild = () => {
    return (
      <>
        {isDashboard && (
          <Typography component="subheading" variant="bold" className="text-gray-850">
            Get Certified
          </Typography>
        )}
        {isAmateur && !isDashboard && (
          <div className="flex gap-1 items-center justify-center medium:!justify-start">
            <Image src={ribbon} alt="ribbon" className="w-10 large:w-[68px] h-[68px]" />
            <Typography variant="bold" component="h2">
              Get Certified
            </Typography>
          </div>
        )}
        {!isAmateur && !isDashboard && (
          <ProfessionalThemeHeader title="Validating Your Success: About Your Certificate" />
        )}
        {!isDashboard && (
          <div className="flex gap-x-4 large:!gap-[30px] xlarge:gap-[150px] justify-between items-center flex-col medium:!flex-row mt-6">
            <div className="flex-col items-left w-full">
              <div className="hidden medium:!flex">
                <SelectionTabs
                  setCertificate={setCertificate}
                  certificate={certificate}
                  setModelOpen={setModelOpen}
                  certificateType={certificateType}
                  isAmateur={isAmateur}
                />
              </div>
            </div>
            <div
              className={`hidden medium:!block w-full
            ${isAmateur ? 'large:h-[410px]' : ''}`}
            >
              <CertificateSection
                certificate={certificate}
                setModelOpen={setModelOpen}
                isAmateur={isAmateur}
              />
            </div>
            <div className="medium:!hidden">
              <SelectionTabs
                setCertificate={setCertificate}
                certificate={certificate}
                setModelOpen={setModelOpen}
                certificateType={certificateType}
                isAmateur={isAmateur}
              />
            </div>
          </div>
        )}
        {isDashboard && (
          <div className="w-full flex flex-col-reverse gap-4 regular:!flex-row py-2 regular:!justify-between">
            <div className="w-full regular:!w-3/5">
              <SelectionTabs
                setCertificate={setCertificate}
                certificate={certificate}
                setModelOpen={setModelOpen}
                certificateType={certificateType}
                isAmateur={isAmateur}
              />
            </div>
            <div className="w-full regular:!w-[230px] bg-white p-2 h-[312px]">
              <img
                src={`${companyImage}/certificateImage/${certificate}?timestamp=${Date.now()}`}
                alt="certificateImage"
                className="w-full h-full"
              />
            </div>
          </div>
        )}
      </>
    );
  };
  return (
    <section id="certificate" data-title="Certifications" className="relative">
      {!isAmateur && !isDashboard && (
        <Image
          src="/images/campusEdgeCourseDescription/main/wave-blue-certificate.svg"
          alt="wave-blue-certificate"
          width={272}
          height={544}
          className="hidden large:!flex absolute right-0 top-[-43px] z-0"
        />
      )}
      {!isAmateur && !isDashboard && (
        <Image
          src="/images/campusEdgeCourseDescription/main/arrow-swirl.svg"
          alt="illustration"
          width={100}
          height={200}
          className="hidden large:!flex absolute left-0 top-1/3"
        />
      )}
      <Dialog
        open={modelOpen}
        closeModal={() => setModelOpen(false)}
        isOutSideClick
        titleWrapperClass="border-none text-black"
        className={`pt-2 w-[90%] large:min-w-[500px] large:max-w-fit ${
          isAmateur ? '' : 'large:!h-[90vh]'
        }`}
      >
        <img
          src={`${companyImage}/certificateImage/${certificate}`}
          alt={certificate}
          className="large:!pb-12 h-full w-full object-contain"
        />
      </Dialog>
      {isDashboard ? (
        <div className="py-4 flex flex-col gap-4">{returnChild()}</div>
      ) : (
        <Container className="medium:!px-8 large:!px-20 py-9 medium:py-14">
          {returnChild()}
        </Container>
      )}
    </section>
  );
};

export default GetCertified;
